import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { CreateOrder, Order } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { kpiKeys } from '&/features/kpis';

import { createOrdersApi, orderKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Creates an order and invalidates the order list and KPI queries. Error/success feedback is owned by the caller (`useSubmitOrder`), which needs the created order's reference number and per-code error mapping. */
export function useCreateOrder(): UseMutationResult<Order, Error, CreateOrder> {
  const client = useApiClient('deliveries');
  const api = createOrdersApi(client);
  const queryClient = useQueryClient();

  return useMutation<Order, Error, CreateOrder>({
    mutationFn: (body: CreateOrder): Promise<Order> => api.createOrder(body),
    ...createMutationCallbacks<Order, CreateOrder>({
      invalidateKeys: [orderKeys.lists(), kpiKeys.all],
      queryClient,
    }),
  });
}
